
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4b75"];
var parcelRegister = parcelRequire.register;
parcelRegister("amr3n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d90b620bc8baa957$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $88FA0 = parcelRequire("88FA0");

var $8kt8E = parcelRequire("8kt8E");

var $duLFK = parcelRequire("duLFK");

var $jlTfJ = parcelRequire("jlTfJ");

var $fGZ1g = parcelRequire("fGZ1g");

var $1qZrx = parcelRequire("1qZrx");
const $d90b620bc8baa957$var$CmsContent = ()=>{
    const { fullUrl: fullUrl } = (0, $8kt8E.useParams)();
    if ((0, $duLFK.isWaitingForData)((0, $jlTfJ.default).urlData) || (0, $duLFK.isDefaultData)((0, $jlTfJ.default).urlData)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
        height: 500
    });
    if ((0, $duLFK.isDataAvailable)((0, $jlTfJ.default).urlData)) {
        const currentUrlData = (0, $jlTfJ.default).urlData.data.find((data)=>data.fullUrl === fullUrl);
        if (currentUrlData) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1qZrx.default), {
            id: currentUrlData.id
        }, `contentPage-${fullUrl}`);
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $fGZ1g.default), {});
};
var $d90b620bc8baa957$export$2e2bcd8739ae039 = (0, $lp3dk.view)($d90b620bc8baa957$var$CmsContent);

});


//# sourceMappingURL=CmsContent.0b849686.js.map
